// prettier-ignore
export default {
  "generic": {
    "permisson_device_orientation_not_allowed": "方向センサー機能を使用するには、ブラウザを再起動してアクセス許可を再度確認することをお勧めします。<br>または、携帯電話を地面に垂直にして次に進むをクリックしてください。",
    "permisson_device_orientation_not_support": "申し訳ありませんが、お使いのブラウザは方向センサー機能をサポートしていません。他のブラウザやデバイスを試すか、<br>携帯電話を地面に垂直にして次に進むをクリックしてください。"
  },
  "terms": {
    "terms": "Cloudzet™ Body Scanning Service (“Service”) is provided by TG3D Studio Inc. Limited and its Affiliates (“TG3D,” “We,” or “us”) under this Terms of Use (the “Terms”). <br><br>When you register the Service, you agree that you have read, understood, and consented to all the content stated in the Terms. If you are a minor, you should make sure your parents (or guardians) read, understand and agree you to comply with the Terms in full before you start using this Service. We reserve the right to modify or amend the Terms. Please visit the Terms from time to time. Your continued use of the Service after any such modification or amendment constitutes your or your parent’s (or guardian’s) acceptance of the new Terms. <br><br>Service <br><br>The Body Measurements and 3D body shape model of the User (collectively,  3D body measurements file) can be scanned and  generated by Cloudzet™ App and the Scanatic 360 Body Scanner.  When User uses the Service in the Third-party Store,  User’s 3D body measurements file is accessible by the Third-party Store for providing the custom-made clothing service and (or) recommendation service of branded clothes  to the User. Also, we will recommend personalized branded clothes to the User. The custom-made clothing service and any branded clothes are provided by the Third-party Store and clothing company, the User should review the pattern, fabric, size, cutting and the delivery of the ordered clothes carefully. <br><br>2. Definition <br><br>Software means the Cloudzet™ App developed by us and/or our affiliates, including, but not limited to, all updated versions, any supplemental and/or external apps and/or software subsequently provided by us. <br><br>User means a user who has completed the membership registration process. (“User”or “you”) <br><br>3D body measurements file means the electronic record containing the information of 3D body shape model and the Body Measurements. <br><br>3D body shape model  means the raw data of body shape shown in 3D format generated in the Service. <br><br>Body Measurements means the User’s body measurements, including but not limited to, Neck circumference, bust, waist and hips, generated in the Service <br><br>Third-party store means the third party company (including its websites and Apps) proving the service of custom-made clothing and the sales of the clothing in the Service. <br><br>3. Registration <br><br>User shall provide mobile number or email and any required information (e.g. name and gender) to complete the registration process. <br><br>User may log in the Service by connecting to your personal account of certain third party social network sites, including but not limited to, Facebook or Weixin. <br><br>4. User’s duty and Obligation <br><br>You agree to provide accurate, complete and true personal information for registration, and you may update such information online at any time. If you provide incorrect or misleading personal information that cause damages to damages to the rights or interests of other users or third parties, we may terminate your user account and use of Services, and you shall be solely responsible for the relevant legal liabilities and/or damages. <br><br>User shall further fulfill the following obligation to secure user account.  <br><br>User account shall be used by User only. You shall only use our Services and Software in accordance with the Terms and shall not allow any third party to access the Services and Software by logging in your user account. <br><br>You are obliged to properly safeguard your user account details, passwords and other relevant information. You shall be fully liable for any and all acts and/or activities, including all related fees, carried out under your user account. <br><br>If you discover any unauthorized use or unusual access to your user account, you should report to us immediately and protect your personal interests through appropriate legal means. If necessary, we will ask you to provide the relevant personal information and have the right to take charge of the account in dispute. <br><br>If unlawful use of user account and passwords is caused by your negligence or third parties’ use of the accounts with your consent, and causes damages to the interests of us or other users, you shall be solely responsible for the relevant legal liabilities and/or damages. <br><br>5. Collection of your information <br><br>Your use of the Service constitutes your consent to the collection, processing and use of your personal information, 3D body model shape and Body Measurements through the Service by TG3D for provide you the Service. <br><br>Restriction <br><br>Subject to your continuous compliance of this Terms and the additional terms and conditions imposed by the relevant Software and Services, you are authorized to use our Services and Software. If we are aware of any breach, we may suspend or terminate your right to use the Software and Services. <br><br>You are authorized to use Software and Service, but you are not allowed to modify, sub-license, lease, sell or assign any of the rights granted under the Terms. You also agree to comply with all relevant laws and regulations and use the Software and Services for lawful purposes only. <br><br>You are only authorized to use the Software. The intellectual property rights of all Software and relevant program codes are owned by us. You are prohibited from modifying, reverse engineering, reverse coding, decompiling (into a human readable format) or dissembling the Software, impeding or interfering with other user’s use of the Software and Services, or disseminating through the Software and Services virus or other malwares which are harmful to the others’ computer operation, software or contents which are in breach of the Terms and any content which may infringe the others’ intellectual property rights or other rights. <br><br>We will take all necessary steps to prevent you from using the Software and/or Services in a manner which is in breach of the Terms or the relevant laws and regulations. <br><br>7. Privacy Policy <br><br>Please refer to the Privacy Policy. <br><br>8. Intellectual Property <br><br>You are only authorized to use the Services and Software, and do not acquire from us the copyright, trademark, patent and/or any other proprietary right in the Services and Software, and any program codes provided by us. For the avoidance of doubt, all rights are reserved by us unless expressly granted to you under the Terms. <br><br>You acknowledge that our Services, Software and technology are protected by the relevant laws of their respective licensed territories and agree not to remove or modify any digital right management information, anti-piracy measures or symbols of other rights (including but not limited to patent right and trade mark right) or software, which are contained in the Services and Software. <br><br>9. Limited liability <br><br>Any information, content, software or services provided by us through Software and/or Services will be provided AS IS at the time of provision. We do not guarantee or warrant the format and content of our Services in the event of Internet connection failure, delay or other relevant communication defect. <br><br>Unless otherwise expressly stated in the law, in no event, shall we and/or our authorized agents be liable for any loss or damages, including losses caused by the use of Software and/or Services, the failure to use Software and/or Services, and/or other direct, indirect, accidental, special or consequential losses, including but not limited to loss of business profits, business loss, business interruption, business information loss and any other monetary loss. <br><br>We will not warrant and be liable for any damages or defects arising out of any and all disputes between you and the Third-party Store or any and all intentional or negligent act of other users. <br><br>Any dispute arising out of or in connection with the transaction between User and the Third-party Store or any clothing company shall be solved by the User and Third-party Store or clothing company. TG3D is not liable for any damages or defects arising out of or in connection with such disputes. <br><br>10. Amendment <br><br>We reserve the right to amend the Terms from time to time. You will be deemed to have accepted the amendments when you continue to use our Software and Services after we announce the amended Terms on our website or APP. <br><br>11. Laws and Jurisdiction <br><br>The Terms shall be construed, supplemented and applied in accordance with the laws of the Republic of China. For any matter which is not covered herein, please contact our customer service. Both parties agree that all disputes arising out of the Terms shall be subject to the jurisdiction of the Taiwan Taipei District Court if they cannot be resolved through negotiation and the parties have to resort to litigation.",
    "privacy": "TG3D Studio Inc. Limited and its affiliates (“We”) take your personal privacy seriously and duly comply with the relevant privacy and personal information protection laws and regulations. Our Privacy Policy (the “Policy”), which explains what personal information we collect and how to use such data, as well as other important matters related to your privacy, is set out as the following. <br><br>When you register as a User of Cloudzet™ App (the “Service”), you will be required to enter certain information, including, but not limited to, an account ID (mobile number or email address), name, gender and date of birth. <br><br>If you connect your account via Facebook, WeChat or other services (“Third Party Service”), you agree us to collect your personal verification information and other data that may be accessible from your Third Party Service account, including your name, profile photos, country, email address, date of birth, gender, names of friends, and other personal pictures and social network. We may verify whether your data matches those collected from such Third Party Service and will store and use such data pursuant to the Policy. <br><br>When you use the Service, we may collect the following information：  <br><br>your body measurements, 3D body shape model, height, weight location information and address; <br><br>information about your use of the Service, include camera, photos and the information stored in the SD card; and <br><br>technical information, such as URL, IP address,web browser type , operation system of your device, language, and the time of visit. We employ Google Analytics to collect the aforementioned information. You could find more information about the privacy policy of Google Analytics and how to disable Google Analytics by visiting Google’s Data privacy and security. You could disable Google Analytics by downloading and installing Google Analytics Opt-out Browser Add-on. <br><br>To properly and promptly provide you with the Service, you will be required to provide the user account and the contact information when you use the Service, including but not limited to, procurement, changing the information of user account, feedback or participating in any promotional activities. <br><br>The information we collected will be used as the following: <br><br>The basic personal information you provide (such as your name) will be used for the purpose of User identification for TG3D and the Third-party store; the contact information you provide may be used for contacting you, notifying you promotional events, payment reminder, award notice, payment receipt notice, sending invoices, branded clothes recommendation and/or other update notices related to the Service. If you do not want to receive any promotional email or text message, please contact support@tg3ds.com. <br><br>Your 3D body shape model and Body Measurements will be used for providing you ,  and the service of made-to-measure,, bespoke and the recommendation of brand clothes by the Third-party Store and the recommendation service of personalized branded clothes from us. <br><br>Information about your use and technical data and 3D body measurements file generated etc. from your use of this Service may be used for improving the Service, and/or developing new services. <br><br>We will provide you for ours or any third party’s promotional information and advertisement from time to time by push notification. If you no longer wish to receive these types of communications, or if you've initially agreed for the application to access your camera, photo and SD card and you would like to stop the app from accessing them, you may turn them off at the device level. <br><br>You understand and agree that we may share with third parties the data which  is not able to reflect or specify any identifiable individual.  <br><br>The data collected herein may be processed and/or used by our affiliates or partners or outside Taiwan. We will not use them for any other purposes unless the local laws provide otherwise, and will also not disclose them to any third party without your prior consent, unless the laws require so due to material national interests or for the purpose of facilitating law enforcement agencies’ investigations. <br><br>You may search, copy or change your own personal Information. If you are not our User or we have not yet verified your membership, you are not allowed to search, copy, request for review or change the user’s personal information and account services of our accounts. For requests made in circumstances other than above, you would be required to provide your relevant personal information and written documentation as may be necessary to enable us to process your request. <br><br>You may request the use of your personal information be suspended or your own personal information be deleted.  However, once the use is suspended or personal information is deleted, you will no longer be able to use the Service. You may exercise your right to portability to obtain a copy of  your personal data provided to us. You may object to process the processing of your personal data and withdraw your consent to processing for marketing and profiling. you can always exercise your rights described above by sending a written request to us at the following address: support@tg3ds.com <br><br>You grant us an irrevocable right to use the data which is not able to reflect or specify any identifiable individual for the improvement of the Service and relevant technology and the development of the new service. <br><br>We are entitled to refuse your request to change, delete or modify your personal information if such request may be harmful to the material national interests, result in impediment to the execution of statutory duties by government agencies, or cause any prejudice to the material interests of the collecting agency or third party. <br><br>We will provide all necessary technologies and measures to protect your personal information in order to safeguard your privacy. <br><br>To avoid information leakage, you should keep your own personal information, user account and password, etc. in safe custody. To avoid misuse of your personal information, you should log out or close the software or internet browser after using the Services, whether you are using your own personal computer or not. <br><br>You should keep your payment information (including credit card details) in safe custody to avoid being used by others for illegal purpose. <br><br>The Service may include hyperlinks to third parties’ websites or web pages. We are not held jointly liable if you agree to allow those websites to collect, process, and/or use your personal information. <br><br>You agree to use true and accurate information for purchases on the Service. You should notify us immediately if you find your personal information has been misused by others or if you find something abnormal. <br><br>You agree to provide and use lawful information when using the Services and all such information does not infringe any third party’s rights, violate any third party’s agreement or otherwise involve any illegal acts. If use of the Services causes any third party’s loss, we are not liable for such loss unless it is caused by us intentionally or due to our gross negligence. <br><br>We may update this Policy from time to time and comply with the relevant local privacy laws and regulations. When we make significant changes, we will make an announcement on our official website(http://www.tg3ds.com) or APP. <br><br>This Policy constitutes part of the Terms of Service. If you do not agree any part of this Policy or any amended content, please stop using the Service immediately. <br><br>If you have any question regarding the Policy, please contact us at support@tg3ds.com"
  },
  "login": {
    "cloudzet_welcome": "Cloudzet へようこそ",
    "mtm_username": "Scanatic™ アカウント",
    "password": "パスワード",
    "login": "ログイン",
    "logging_in": "ログインしています...",
    "no_login_methods": "この Scanatic™ アカウント用のログイン方法が設定されていません。",
    "agreements_button": "同意して次へ進む",
    "complete_email_reset_pwd_title": "応援します!",
    "sent_email": "次宛に電子メールを送信しました",
    "email_reset_pwd": "指示に従ってパスワードをリセットしてください。",
    "get_the_code": "コードがありませんか?",
    "resend": "再送信",
    "complete_phone_reset_pwd_title": "おめでとうございます!",
    "login_new_password": "新しいパスワードが設定されました。<br />新しいパスワードを使ってログインしてください。",
    "login_my_account": "アカウントにログインする",
    "sent_a_code": "次宛にコードを送信しました",
    "received_code": "受け取ったかどうかご連絡ください。",
    "verification_code_error": "検証コードエラー",
    "continue": "次へ進む",
    "forget_your_password": "パスワードをお忘れですか?",
    "forget_password_text": "心配ありません。",
    "send": "送信",
    "submit": "提出",
    "no_such_user": "アカウントが見つかりません",
    "email_prompt_text": "パスワードをリセットするための電子メールをお送りします。",
    "phone_prompt_text": "4 桁の検証コードをお送りします。",
    "login_title": "ようこそ!",
    "login_email_title": "電子メールでログイン",
    "login_phone_title": "スマートフォンでログイン",
    "forget_password": "パスワードをお忘れですか?",
    "terms_of_service": "サービスご利用規約",
    "choose_a_country_code": "国コードを選択する",
    "choose_a_country_code_hint": "ログイン/登録は次の国と地域でのみ利用可能です。",
    "country_code_not_found": "国コードが見つかりませんか？",
    "sign_up_email": "電子メールでサインアップ",
    "email_sign_up_error_msg": "正しい電子メールアドレスを入力してください。",
    "four_characters": "パスワードは少なくとも 4 文字でなければなりません。",
    "try_to_login": "このアカウントは既に存在します。ログインをお試しください。",
    "try_use_email": "メールを使ってみてください",
    "sign_up": "サインアップ",
    "sent_verification_code": "4 桁の検証コードをお送りします。",
    "sign_up_phone": "スマートフォンでサインアップ",
    "sign_up_store": "ストアでサインアップ",
    "set_up_new_pwd": "次に、新しいパスワードをセットアップします。",
    "set_up_new_password": "これで、新しいパスワードを<br>セットアップできます。",
    "set_new_pwd": "新しいパスワードを設定する",
    "enter_country_code": "国コードを入力する",
    "enter_email_address": "電子メールアドレスを入力する",
    "enter_phone_number": "電話番号を入力する",
    "customer_account_name": "カスタマーアカウント名",
    "enter_password": "パスワードを入力する",
    "re_enter_password": "パスワードをもう一度入力する",
    "login_social_accounts": "ソーシャルアカウントでサインアップ",
    "social_login_failed": "ソーシャルアカウントでのログインに失敗しました。",
    "login_first": "まずログインしてください",
    "wrong_password": "正しいパスワードではありません。もう一度確認してください。",
    "get_the_email": "メールが届きませんか？"
  },
  "sanne": {
    "login_welcome": "Sanne へようこそ",
    "welcome_title": "the arc へようこそ。",
    "tap_camera_on": "ここをタップしてカメラを起動し、個人用 QR コードをスキャンしてください",
    "tutorial_remove_acc": "スキャンの前にアクセサリー類をすべて外し、スマートフォンと一緒にスタンドに置いてください",
    "tutorial_step": "ステップ {n} / {total}",
    "end_hint": "お帰りの際はお荷物をすべてお持ちになり、スキャンルームのドアを閉めてください。ドアは自動でロックされます。",
    "generating": "採寸データを生成しています",
    "scan_code_title": "QR コードをスキャンしてください",
    "tutorial_wear_tight": "肌に密着した、体にフィットする服を着てください",
    "step_info": "準備ができたら、<br>こぶしをバブルの中に上げてください",
    "feet_pos": "マークの位置に足を合わせてください",
    "raise_both_arm": "腕をゆっくり上げて、こぶしをバブルの中で止めてください",
    "scan_in_progress": "スキャン中...",
    "network_error": "インターネット接続を確認してください",
    "enable_bt": "Bluetooth をオンにして、近くのスキャナーを検索してください",
    "avoid_errors": "スキャンエラーの主な原因",
    "login_s4f": "Scanatic™ for Fashion でログイン",
    "end_title": "採寸が完了しました！",
    "log_in": "ログイン"
  },
  "stamp": {
    "tap_to_start": "スキャン開始手順を読み<br>準備ができたら、タップしてください",
    "tap_camera_on": "指でタップしてカメラを起動",
    "welcome_title": "Welcome to<br>STAMP SCAN BOX",
    "note_front_camera": "あなたのスマートフォンを使ってLINE上からSCAN CODEを起動し、前面のカメラにかざしてログインしましょう",
    "scan_code_title": null,
    "scan_code_hint": "SCAN CODEを枠内にかざしてください",
    "things_to_note_title": "Before The 3D Body Scan",
    "clothes_info": "肌に密着した下着のみになってください<br>衣類はボックスに入れてください",
    "clothes_alt_info": "男性のトランクス、女性のブラトップなど、ゆとりのありすぎる衣類では、正常にスキャンできない場合があります",
    "accessories_info": "メガネ以外のアクセサリー類は外してください<br>髪の長い方は首にかからないように結んでください",
    "accessories_alt_info": "ヘアゴムはボックス内に、用意しています",
    "touch_for_tutorial": "スキャンの準備ができたら指でタップ",
    "tutorial": {
      "title": "The Contactless Control Tutorial",
      "contactless": "3Dスキャンの操作ガイドを始めます",
      "clench_fingers": "両手は軽く握り、握り拳を作ります",
      "raise_arm": "マークの位置まで両腕をあげます",
      "raise_arm_2": "マークの位置でセンサーが反応し、スキャンが始まります",
      "feet_pos": "足型に合わせて気を付けの姿勢で立ちます"
    },
    "choose_to_start": {
      "title": "3D Scan Tutorial",
      "start": "マークの位置まで両腕をあげてください",
      "done": "この体制でスキャンが始まります"
    },
    "end_goodjob": "おつかれさまでした",
    "end_line": "LINEスキャンメニューからカメラを起動し、<br>QRコードを読み取ってチェックアウトしましょう",
    "choose_step_info": "マークの位置まで右腕をあげてください",
    "clench": "両手は軽く握り、握り拳を作ってください",
    "feet_position": "足型に合わせて気を付けの姿勢で立ってください",
    "raise_arm": "マークの位置まで両腕をあげてください",
    "hold_left": "左腕を、マークの位置までゆっくりあげてください",
    "hold_right": "右腕を、マークの位置までゆっくりあげてください",
    "scan_step_name_begin": "Begin the 3D Body Scan",
    "scan_step_name": "3D Body Scan",
    "scan_step_name_2": "2nd Time 3D Body Scan",
    "scan_body_start": "マークの位置まで両腕をあげてください",
    "scan_in_progress": "スキャンが始まります<br>そのまま動かないでください",
    "scan_complete_1": "1回目のスキャンに成功しました。<br>腕を降ろして、リラックスして下さい",
    "scan_complete_2": "2回目のスキャンに成功しました。<br>腕を降ろして、リラックスして下さい",
    "analyzing": "3Dデータを生成しています",
    "leave": "ログアウト",
    "end_next": "スキャンを終了する",
    "end_next_info": "Next Information",
    "end_instruction": "洋服を着て下さい。<br> 続けて、外のタブレットへと移動し、<br> 新たな体験をお楽しみください。",
    "scan_again": "もう一度スキャン",
    "scan_unsuccessful": "スキャンに失敗しました",
    "scan_successful": "スキャンデータの生成に成功しました",
    "neck": "首回り",
    "chest": "チェスト",
    "chest_female": "バスト",
    "torso": "胴回り",
    "mid_waist": "ウエスト",
    "hip": "ヒップ",
    "shoulder": "肩幅",
    "biceps": "上腕回り",
    "arm": "腕丈",
    "thigh": "太もも",
    "inner_leg": "股下-地面",
    "avoid_errors": "スキャン時の注意事項を確認してもう一度スキャンしてください",
    "error_accessories": "メガネ以外のアクセサリー類を外してください",
    "error_cover_neck": "髪の長い方は首が隠れないよう結んでください",
    "error_floor_marks": "足型に合わせて立ってください",
    "error_postural": "スキャン時は姿勢を正してください",
    "welcome_steps": "スキャン開始手順",
    "welcome_step_1": "靴と鞄はボックスに入れてください",
    "welcome_step_2": "LINE下部メニューのスキャンコードをタップしQRコードを発行します"
  },
  "hm": {
    "end_title": "Thank you!",
    "end_text": "You can now return to the Body Scan Jeans Design Station to customize your jeans.<br>Remember to carry your personal belongings with you."
  },
  "welcome": {
    "enable_bt": "次へ進む前に Bluetooth をオンにしてください。",
    "welcome_title": "3D スキャニングルームへ<br> ようこそ",
    "powered_by": "TG3D Studio Inc. がお届けします",
    "tap_to_start": "バブルをタップして開始します",
    "tap_camera_on": "カメラをオンにして QR コードをスキャンします",
    "ready_to_scan_qr": "QR コードをスキャンする準備ができました",
    "note_front_camera": "あなたのスマートフォンでLINEを起動して、ログインQRコードを画面に表示してください。",
    "scan_code_title": "QR コードをスキャンして始めます",
    "scan_code_hint": "QR コードをボックスに入れてください",
    "scan_code_processing": "処理しています...",
    "scan_code_logging_in": "アカウントにログインしています...",
    "scan_code_connect_to_scanner": "スキャナーに接続しています...",
    "scan_code_no_account": "ログインに失敗しました。もう一度、ログインQRコードを、かざして下さい。",
    "scan_code_done": "準備ができました。",
    "no_scanner_id": "この Scanatic™ アカウント用のスキャナー ID がセットアップされていません。",
    "no_scanner_found": "指定されたスキャナーが見つかりません。",
    "scanner_in_use": "スキャナーは使用中です",
    "unexpected_error": "問題が発生しました :("
  },
  "choose": {
    "step_name": "3D ボディスキャンの準備",
    "step_info": "準備ができたら、<br>手でハンドルを握って持ち上げてバブルの中に入れます。",
    "tutorial": "チュートリアル",
    "start_scan": "3D スキャン",
    "clench_fingers": "両手を軽く握ってください。",
    "raise_arm": "バブルに触れるまで腕を上げます。",
    "hold_til_fill": "バブルが満たされるまで腕を上げたままにします。"
  },
  "thingstonote": {
    "title": "3D ボディスキャンの前に",
    "wear_tight": "肌に密着した下着のみになってください。男性のトランクスや、女性のブラトップなど、肌に密着していない服装ではスキャンができません。",
    "tie_hair": "首の後ろにかからないように髪を束ねてください。",
    "remove_acc": "アクセサリー類はすべて外してください。"
  },
  "scanscreen": {
    "skip": "スキップ"
  },
  "tutorial": {
    "title": "The Contactless Control Tutorial",
    "contactless": "The contactless experience ensures your health is protected",
    "clench_fingers": "Lightly clench your fingers",
    "raise_arm": "To control the bubbles, please raise your arms until you touch the bubbles and hold for 2 seconds",
    "hold": "Now hold until the bubble is filled",
    "proceed": "To proceed to the next step, raise your right arm until it touches the bubble.",
    "return": "To return to the previous step, raise your left arm until it touches the bubble.",
    "feet_pos": "Position your feet on the floor mat"
  },
  "scan": {
    "feet_pos": "足型に合わせて気を付けの姿勢で立ちます",
    "step_name": "3D ボディスキャン",
    "begin_2nd": "2つ目のポーズの 3D ボディスキャンを始める",
    "clench": "両手を軽く握ってください。",
    "raise_both_arm": "腕をゆっくりと上げて、ハンドルを握った手をバブルの中に入れます。",
    "raise_fists": "手でハンドルを握って持ち上げて、バブルの中に入れます。",
    "lower_fists": "手でハンドルを握って押し下げて、バブルの中に入れます。",
    "hold_still": "腕を動かさないでください。",
    "scan_keep_still": "体を動かさないでください。",
    "scan_in_progress": "スキャン中です",
    "scan_complete": "スキャンが完了しました。腕を降ろして、リラックスして下さい。",
    "two_step_scan": "スキャンは、2段階で行われます。",
    "scanner_occupied": "スキャンルームは使用中です。スタッフに声をかけてください。",
    "scanner_error_need_reset": "エラーです。スタッフに声をかけてください。再起動後、もう一度お試しください。",
    "scanner_error_generic": "エラーです。スタッフに声をかけてください",
    "scanner_not_activated": "スキャナーが起動していません。スタッフに声をかけてください。",
    "scanner_check_network": "スタッフにスキャナーがインターネットに接続されているか確認してください。もしくはスキャナー再起動し、もう一度お試しください。"
  },
  "handles": {
    "hold": "Hold the Handles; Feet on the Floor Marks",
    "hold_ready": "Hold the Handles. You Are Now Ready",
    "letgo_and_keep_feet": "Let go the handles & keep your feet on the floor marks",
    "clench_ipose": "Fists lightly clenched, hands about 5 cm (2 inches) apart from body",
    "clench_ready": "Fists lightly clenched, You Are Now Ready"
  },
  "end": {
    "thank": "ありがとうございました。",
    "belonging": "所持品を忘れずにお持ち帰りください。"
  },
  "analyzing": {
    "check_err": "3D アバターを作成しています..."
  },
  "result": {
    "scan_successful": "お疲れさまでした。3D スキャンが正常に完了しました。",
    "scan_unsuccessful": "データを処理できません。",
    "avoid_errors": "スキャンエラーの一般的な原因",
    "error_accessories": "アクセサリー類を着用している",
    "error_cover_neck": "髪がかかっているので首が見えない",
    "error_floor_marks": "足の位置が間違っている",
    "error_postural": "姿勢が正しくない",
    "leave": "ログアウト",
    "raise": "手でハンドルを握って持ち上げてバブルの中に入れ、もう一度スキャンしてください。",
    "scan_again": "もう一度スキャンする",
    "analyzing": "スキャンデータを処理しています...",
    "click_scan_again": "下のボタンをクリックしてもう一度スキャンします",
    "oops": "おっと！",
    "unexpected_error": "何かがおかしいです...",
    "close": "閉じる",
    "error_top_loose": "トップスがゆるすぎます",
    "error_bottoms_loose": "ボトムスがゆるすぎます",
    "error_outfit_loose": "服装がゆるすぎます",
    "scan_error_detected": "スキャンに問題が検出されました"
  },
  "measurement": {
    "neck": "首周り",
    "chest": "胸囲",
    "torso": "着丈",
    "mid_waist": "腰",
    "hip": "ヒップ",
    "shoulder": "肩幅",
    "biceps": "二の腕",
    "arm": "腕",
    "thigh": "太もも",
    "inner_leg": "脚の内側",
    "chest_female": "胸囲"
  },
  "homePage": {
    "firstScanTitle": "未来への旅を始めます",
    "tap_to_scan": "タップして 3D スキャンする",
    "measurement": "計測",
    "body_3d_avatar": "3D ボディ",
    "see_more": "さらに詳しく",
    "menu": "メニュー",
    "store_settings": "スコア設定",
    "avatar_shader_3d": "3D アバターシェーダー",
    "avatar_shader": "アバターシェーダー",
    "create_3d_shader": "3D シェーダーを作成する",
    "language": "言語",
    "get_help": "ヘルプの取得",
    "feedback": "フィードバック",
    "send_feedback": "フィードバックを送信する",
    "send_btn": "送信",
    "send_feedback_placeholder": "フィードバックを参考にさせていただいて、製品とサービスの改善に役立てます。",
    "send_feedback_title": "フードバックをお寄せいただきありがとうございます。",
    "send_feedback_content": "フィードバックを参考にさせていただいて、より良い体験を提供できるように取り組んでまいります。ご意見・ご感想を是非お聞かせください。",
    "report_crash": "クラッシュを報告する",
    "report_crash_title": "ご連絡ありがとうございます。",
    "report_crash_content": "問題が発生したことをお詫び申し上げます。<br>弊社のチームができるだけ早くこの問題を調査いたします。その他の問題がありましたら、遠慮なくご連絡ください。",
    "rate_app": "Cloudzet アプリを愛用している",
    "rate_app_title": "Cloudzet アプリを評価する",
    "rate_app_content": "Cloudzet アプリを愛用している方は、App Store で評価やレビューを投稿してください。お時間をいただきましてありがとうございます。",
    "login_s4f": "Scanatic™ アカウントでログインする",
    "login": "ログイン",
    "password": "パスワード",
    "account_settings": "アカウント設定",
    "enter_Scanatic_account": "Scanatic™ アカウントを開く",
    "logout": "ログアウト",
    "delete_account": "アカウントを削除する",
    "confirm_delete": "よろしいですか?",
    "contactless_scan": "コンタクトレススキャン",
    "delete": "削除",
    "cancel_delete": "キャンセル",
    "ok": "OK",
    "go_to_app_store": "App Store へ移動",
    "measure": "計測",
    "history_tab": "履歴"
  },
  "settingUserData": {
    "your_birth": "生まれた年はいつですか?",
    "your_gender": "性別",
    "female": "女",
    "male": "男",
    "tall": "身長はどれくらいですか?",
    "cm": "Cm",
    "inch": "Inch",
    "your_height": "身長",
    "your_weight": "体重はどれくらいですか?",
    "weight": "体重",
    "lbs": "Lbs",
    "kg": "Kg",
    "nickname": "お名前",
    "lets_go": "さあ始めましょう"
  },
  "profile": {
    "profile": "プロフィール",
    "edit_profile": "プロフィールを編集する",
    "name": "名前",
    "birthday": "誕生日",
    "birthyear": "誕生年",
    "phone": "電話番号",
    "address": "住所",
    "save": "OK"
  },
  "discovery": {
    "turn_on_bt": "Bluetooth をオンにする",
    "turn_on_bt_hint": "Bluetooth を許可して有効にする",
    "turn_on_bt_hint_ios": "次の設定が完了していることを確認してください：<br>1. 権限を付与する<br>　● 設定 > プライバシーとセキュリティ > Bluetooth に移動し、Cloudzet へのアクセスを許可してください。<br>2. Bluetooth をオンにする<br>　● 設定 > Bluetooth に移動してオンにしてください。",
    "turn_on_bt_hint_android": "次の設定が完了していることを確認してください：<br>1. Bluetooth をオンにする<br>　● 画面の上から下にスワイプして、Bluetooth をタップします。",
    "searching": "近くのスキャナーを検索しています...",
    "select_scanner": "近くのスキャニングルームを選択して開始する",
    "scanner__foot": "フットスキャナー",
    "scanner__body": "ボディスキャナー",
    "start_scan": "3D スキャンを開始する",
    "no_scanners": "近くのスキャナーが見つかりません。",
    "try_again": "もう一度お試しください。",
    "scanner_is_busy_title": "スキャナーは使用中です",
    "scanner_is_busy_desc": "使用中の人がいないか確認してください",
    "scanner_is_busy_force_release": "今すぐスキャン",
    "scanner_is_busy_wait": "スキャンを待ってください"
  },
  "footscan": {
    "take_off": "フットスキャンの準備<br>靴を脱いでください。",
    "barefoot": "ぴったりフィットする靴下を履くか、<br>または裸足になってください。",
    "show_ankles": "ズボンのすそをまくり上げて<br>足首を出してください。",
    "sit": "<br>膝を 90° にして椅子に座ってください。",
    "position_feet": "床に印の上に足を置いてください。",
    "start_scan": "スキャン",
    "ready_to_scan": "準備完了です！",
    "stand_up_for_2nd_scan": "立ち上がって、まっすぐ前を向き、2 回目のスキャンの準備をします。",
    "stand_still": "身体を動かさないで<br>顔を前に向けます",
    "scan_complete": "スキャンが完了しました<br>リラックスしてください",
    "creating_3d_foot": "3Dの足モデルを作成中です...",
    "scan_successful": "よくできました！<br>あなたの3Dスキャンは無事に完了しました",
    "click_to_rescan": "下のボタンをクリックして<br>もう一度スキャンします",
    "feet_3d": "3Dの足",
    "analysis": "足分析",
    "initial_l": "左",
    "initial_r": "右",
    "tab__fit": "靴のサイズ",
    "tab__width": "幅",
    "tab__arches": "アーチ",
    "tab__measure": "計測",
    "tab__type": "タイプ",
    "shoes_guide": "靴サイズの目安",
    "shoes_last": "あなたの靴型",
    "measurement__ball": "足囲周囲",
    "measurement__foot_length": "長さ",
    "measurement__foot_width": "幅",
    "measurement__instep": "インステップ 周囲",
    "measurement__span": "スパン  周囲",
    "measurement__arch": "アーチ",
    "measurement__finger_shape": "足のタイプ",
    "arch_type__title": "あなたの足のアーチ",
    "arch_type__high": "高いアーチ",
    "arch_type__summary_high": "弓形足は、立っているときでもアーチが高いです。また、次のような症状が現れる場合があります。",
    "arch_type__desc_high": "• ハンマートウ（指が曲がっている）またはクロートウ。<br><br>  • 足囲、足の横やかかとが固くなる。<br><br>  • 立っている時や歩いている時に痛い。<br><br>  • かかとが内側に傾いているため不安定で、足首の捻挫を引き起こす可能性がある。<br> <br> 推奨の靴タイプ：<br> クッションがあり、衝撃吸収力が高い靴が適しています。足底の固さは、約45度で、厚過ぎず薄過ぎないもの。高いインソールを入れると、アーチをサポートし、足にかかる体重を分散させ、脚への影響を軽減します。",
    "arch_type__normal": "正常なアーチ",
    "arch_type__summary_normal": "アーチの真ん中が半分くらい浮いていれば、正常なアーチです。",
    "arch_type__desc_normal": "正常なアーチでよかったですね。日々の運動と適切な体重を維持してください。心配はありません。<br> <br> 推奨の靴タイプ：<br> 足に体重が均一に分散されていますので、どんなタイプの靴でも適します。",
    "arch_type__low": "低いアーチ",
    "arch_type__summary_low": "弓形足のアーチは、低い、またはフラットです。つまり、立っている時に、足裏全体が地面に触れています。また、以下の症状が現れる場合があります。",
    "arch_type__desc_low": "長時間歩いたり、立ち姿勢であると、特にアーチやかかと部分が痛い。<br> - 歩いたり、走ったりしている時に転びやすい。<br> - 体重が不均一に分散されるので、立ち姿勢が不安定になり、靴の内側が摩耗しやすいです。 <br> <br> 推奨の靴タイプ：<br> アーチを高くサポートする靴や足底が、足首の捻挫を防いでくれます。足底の固さは、40～60度くらいで、柔らか過ぎず、しっかして安定感があるものがよいです。靴の幅は、柔軟性があり、足が動く余地があるものがよいです。かかと部分は、ぴったりしたものがよいでしょう。",
    "foot_type__title": "あなたの足のタイプ",
    "foot_type__egyptian": "エジプト型",
    "foot_type__summary_egyptian": "足の親指から小指にかけて短くなっていくつま先",
    "foot_type__desc_egyptian": "アジア人のほとんどの足は、親指が長く、指の骨が傾斜しています。<br><br> <br> 推奨の靴タイプ：<br> つま先が窮屈になるのを避けるために、つま先に少し傾斜がある靴が最適です。<br> 先のとがった靴はふさわしくありません。体重のほとんどが足の親指にかかるため、外反母趾になりやすいです。",
    "foot_type__roman": "ローマ型",
    "foot_type__summary_roman": "親指から3本目までの指が等しい長さで、残りの2本が短いつま先。",
    "foot_type__desc_roman": "このつま先の形は、親指から3本目までの指が同じ長さで、他の2本が短いという特徴があります。このタイプのつま先の人は、身体も性格もバランスが取れていると言われています。<br> <br> 推奨の靴タイプ：<br> すべての指に余裕があり、それぞれが圧迫し合わない、幅の広い靴が適しています。",
    "foot_type__greek": "ギリシャ型",
    "foot_type__summary_greek": "2番目の指が親指も含めた他の指よりも長いつま先。",
    "foot_type__desc_greek": "このつま先は、2番目の指が他の指より長く、他の指は、足の外側に向かってだんだん短くなります。古代ギリシャ人がこの形のつま先が魅力的だと思っていたことから、ギリシャ型と呼ばれています。興味深い事実：古代ギリシャの多くの像や自由の女神もすべてギリシャ型のつま先をしています。<br> <br> 推奨される靴タイプ：<br> つま先が丸い形のもの、楕円形のもの、つま先を踏まない靴がお勧めです。体重が2番目の指にかかるので、柔らかく柔軟なサポートがあり、前の方にクッションがあるものが適しています。",
    "foot_type__unknown": "不明",
    "foot_type__summary_unknown": "サマリー不明",
    "foot_type__desc_unknown": "記述不明"
  },
  "mobileScan": {
    "mobile_scan": "モバイルスキャン",
    "body_scanner": "ボディスキャナ",
    "data_processing": "スキャンデータ処理",
    "comeback_later": "3Dアバターを確認するために5〜10分後に戻ってきてください",
    "data_process_failed": "スキャンデータを処理できません",
    "error_not_inscreen": "画面に全身が捉えられていません",
    "error_messy_background": "背景があまりにも散らかっています",
    "device_unsupported": "あらっ！<br>あなたのデバイスはモバイル電話の3Dスキャンをサポートしていません",
    "need_faceid": "モバイル3Dボディスキャンは、Face IDを備えたiPhone Xまたは新しいiPhoneでのみ操作できます",
    "scanner_name": "モバイル3Dボディスキャン",
    "confirm_info": "個人情報をご確認ください",
    "begin_title": "スキャンの準備をする",
    "begin_info": "肌にぴったりした服を着て髪を結んで、首の後ろを見せるようにしてください",
    "start_tutorial": "チュートリアルを開始する",
    "not_first": "こちらでは初めてではありませんか？",
    "skip_tutorial": "チュートリアルをスキップする",
    "vertical_info": "平らな表面に電話を垂直に置いてください",
    "inscreen_info": "体全体がキャプチャされていることを確認してください",
    "backoff_info": "次へをクリックして、10秒以内にスキャンのポーズをとり直してください",
    "spin_info": "指を握り、腕を開き、10秒以内に360°回転してください",
    "check_title": "スキャンの準備ができました",
    "check_info": "以下のチェックリストを確認してください",
    "wear_tight": "皮膚をぴったりとした服を着用し、髪を結んでください",
    "wipe_front": "フロントカメラレンズをきれいにする",
    "volume_up": "ボリュームを最大まで上げる",
    "next": "次へ",
    "start_scan": "Start Scan",
    "starting_in": "〜から開始",
    "preview_info": "以下のチェックリストを確認してください",
    "preview_inscreen": "全身がキャプチャされました",
    "preview_arms_open": "Arms opened and fingers clenched",
    "preview_spin": "360°回転",
    "preview_delete": "The video will be deleted once avatar is created",
    "rescan": "再度スキャンする",
    "uploading": "スキャンデータ処理中... ウィンドウを閉じないでください",
    "uploading_done": "解析が完了しました！ 5〜10分後に3Dアバターを確認してください",
    "finish_btn": "終了する",
    "upload_error": "The mobile 3D body scan function isn't enabled<br>Please contact your selected store for more information",
    "no_balance": "The mobile 3D body scan function is suspended<br>Please contact your selected store for more information",
    "scan_limit_reached": "You have reached your scanning limits for this month<br>(each scan account is capped at 3 times per month)",
    "leave": "Leave",
    "no_credits": "Oops!\nYou don't have enough credits",
    "no_email": "Oops!\n You have to enter \nyour email address first",
    "credits": "Your Credits",
    "purchase": "Buy Credit",
    "purchase_cart": "My Cart",
    "purchase_total": "Total",
    "purchase_item": "Item",
    "purchase_checkout": "Checkout",
    "purchase_reminder": "We will send an invoice to your email address.",
    "payment_succeed": "Congratulations! \nYour order has been placed",
    "payment_succeed_des": "We will send an email\nto confirm your order details",
    "update_email": "Update Email",
    "front_info": "正面の写真では、Aポーズを保ち、動かず立っていてください",
    "side_info": "側面の写真では、左を向き、腕を体に近づけて動かず立っていてください",
    "qr_not_valid": "QRコードが無効です",
    "qr_not_valid_desc": "新しいQRコードについては店舗にお問い合わせください",
    "back_to_home": "ホームに戻る",
    "privacy_info": "安心してスキャンできます — 3Dモデルの作成後、写真は完全に削除されます"
  },
  "mobileScan2": {
    "inscreen_front_info": "画面に体全体が見えるように、腕と脚を少し離してください",
    "inscreen_side_info": "横の写真の場合、左を向いてください。両手を太ももの外側に置いて足をくっつけてください",
    "inscreen_info": "画面に体全体が見えるようにし、テーブルの端が写らないようにしてください",
    "trun_left_info": "左を向いて、両手を太ももの外側に置いて、足をくっつけてください"
  },
  "share": {
    "voucher_expired": "セッションが期限切れです。<br>ページを再読み込みしてください。",
    "no_scan_data": "スキャン結果が見つかりません。"
  }
};
